// The thin stacked bar under each final-standings card: one segment per net
// worth bucket (cash / stocks / properties / houses), sized by its share of the
// total. Zero-value buckets are dropped so the bar never shows a hairline
// segment nobody can read.
import classNames from "classnames"
import {
  WORTH_SEGMENTS,
  type EndGamePlayerWorth,
} from "@/utils/endGameBreakdown"

interface NetWorthBarProps {
  worth: EndGamePlayerWorth
  className?: string
}

const NetWorthBar: React.FC<NetWorthBarProps> = ({ worth, className }) => {
  const total = worth.totalWorth || 0
  const segments = WORTH_SEGMENTS.map((segment) => ({
    ...segment,
    value: Math.max(0, worth[segment.key]),
  })).filter((segment) => segment.value > 0)

  const shown = segments.reduce((sum, segment) => sum + segment.value, 0)

  return (
    <div
      className={classNames(
        "flex h-1.5 w-full overflow-hidden rounded-full bg-white/10",
        className
      )}
    >
      {shown > 0 &&
        segments.map((segment) => (
          <div
            key={segment.key}
            title={`${segment.label}: M${segment.value.toLocaleString()}`}
            style={{
              width: `${(segment.value / (total > 0 ? total : shown)) * 100}%`,
              backgroundColor: segment.color,
            }}
          />
        ))}
    </div>
  )
}

export default NetWorthBar
